import React, { useState, useEffect } from "react";
// import PageHeader from "../../components/PageHeader/PageHeader";
import PageHeader from "../../Components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import "./FAQEdit.css";
import { post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
// import { toast } from "react-toastify";
import Header from "../../Components/Header";
import { leftArrow } from "../../common/Assets/imgs";
import toast from "react-hot-toast";

const FAQEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, mode } = location.state || {};

  const [formData, setFormData] = useState({
    question: "",
    answer: "",
  });

  const [isEditing, setIsEditing] = useState(false);
  const [isLoading,setIsLoading] = useState(false);

  useEffect(() => {
    if (data) {
      setFormData({
        question: data?.question || "",
        answer:
          data?.answer ||
          "Kadugudappa is a community-based platform where people can buy and sell extra homemade food prepared by home chefs in their neighborhood. It connects individuals who have surplus meals with those who crave fresh, home-cooked dishes. By supporting local home chefs, the platform reduces food waste, promotes affordability, and brings the warmth of homemade cooking to everyone. Kadugudappa makes sharing food simple, safe, and meaningful for the entire community.",
      });
    } else {
      // New FAQ mode
      setIsEditing(true);
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value || "",
    }));
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    try {
      if (!formData.question || !formData.answer) {
        toast.error("Please fill in both question and answer");
        return;
      }

      let payload = {
        question: formData.question,
        answer: formData.answer,
      };
      let res;
      if (data?.id) { 
        setIsLoading(true);
        res = await put(URLS.FAQ_EDIT + data.id + "/", payload);
        // res = await put(URLS.FAQ_LIST + data.id + "/", payload);
      } else {
        setIsLoading(true);
        res = await post(URLS.FAQ_ADD, payload);
        // res = await post(URLS.FAQ_LIST, payload);
      }

      if (res?.status === "success") {
        toast.success(res?.message || "Saved successfully");
        setIsLoading(false);
        navigate(-1);
        setIsEditing(false);
      } else {
        setIsLoading(false);
        toast.error(res?.message || "Failed to save");
      }
    } catch (error) {
      console.error("Error saving FAQ:", error);
      setIsLoading(false);
      toast.error(error?.message || "An error occurred");
    }
  };

  console.log("data", data);

  return (
    <>
    <Header/>
    <div style={{marginTop:'7rem',paddingLeft:'10px',paddingRight:'10px' }}>

      {/* <PageHeader
        title="FAQ"
        showBackButton={true}
        onBackClick={() => navigate(-1)}
      /> */}
      <div onClick={() => navigate(-1)} className="admin-header mb-0">
                                  <img src={leftArrow} className="back-icon-arrow" />
                                  <h2>FAQ</h2>
                              </div> 
      </div>
      <div className="faq-edit-container">
        <div className="faq-edit-form">
          <div className="form-group">
            <label>Question</label>
            <input
              type="text"
              name="question"
              value={formData?.question || ""}
              onChange={handleChange}
              disabled={!isEditing}
              readOnly={!isEditing}
              placeholder="What is your question?"
            />
          </div>

          <div className="form-group">
            <label>Answer</label>
            <textarea
              name="answer"
              value={formData?.answer || ""}
              onChange={handleChange}
              disabled={!isEditing}
              readOnly={!isEditing}
              rows={10}
              placeholder="Enter the answer here..."
            />
          </div>

          <div className="form-actions">
            {!isEditing ? (
              <button type="button" className="btn-edit" onClick={handleEdit}>
                Edit
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => {
                    if (data) {
                      setIsEditing(false);
                    } else {
                      navigate(-1);
                    }
                  }}
                >
                  Cancel
                </button>
                <button type="button" className="btn-save" onClick={handleSave}>
               
                    {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white", padding: 8 }}
                ></span>
              </>
            ) : (
              "Save"
            )}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      
    </>
  );
};

export default FAQEdit;
